import Repository from "./Repository";

const WHATSAPP_USER_INFO = "/getUserInfo";

export default {
  getUserInfo(payload) {
    return Repository.post(transformRoute(WHATSAPP_USER_INFO), payload);
  },
};
const transformRoute = (route) => {
  return `/whatsapp${route}`;
};
